import { useEffect, useMemo, useState } from 'react';
import { readCachedCareerData, writeCachedCareerData } from '../services/careerDataCache';
import { loadAllCareerData } from '../services/csvDataService';

export function usePlayerCareerData(enabled = false) {
	const [seasonDataByYear, setSeasonDataByYear] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!enabled) return undefined;

		let cancelled = false;
		(async () => {
			try {
				setLoading(true);
				setError(null);

				const cached = await readCachedCareerData();
				if (cached && !cancelled) {
					setSeasonDataByYear(cached);
					setLoading(false);
					return;
				}

				if (!cancelled) setSeasonDataByYear(null);
				const loaded = await loadAllCareerData();
				if (!cancelled) {
					setSeasonDataByYear(loaded);
					await writeCachedCareerData(loaded);
				}
			} catch (err) {
				if (!cancelled) {
					setError(err.message || 'Erreur de chargement des données carrière.');
					setSeasonDataByYear(null);
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();

		return () => { cancelled = true; };
	}, [enabled]);

	const individualsByYear = useMemo(() => {
		if (!seasonDataByYear) return null;
		return Object.fromEntries(
			Object.entries(seasonDataByYear).map(([year, seasonData]) => [
				year,
				seasonData.individuals,
			]),
		);
	}, [seasonDataByYear]);

	return { seasonDataByYear, individualsByYear, loading, error };
}
